import styled from "styled-components";
import {
  Modal,
  Form,
  InputGroup,
  FormControl,
  ModalDialog,
} from "react-bootstrap";
import DateTimePicker from "react-datetime-picker";
import { useSelector } from "react-redux";

// import DateTimePicker from 'react-date-picker/dist/entry.nostyle';

export const MyModal = (props) => {
  const theme = useSelector((s) => s.theme.theme);
  return <Modal {...props} data-theme={theme.themeName} />;
};

export const MyModalDialog = (props) => {
  const theme = useSelector((s) => s.theme.theme);
  return <ModalDialog {...props} data-theme={theme.themeName} />;
};

export const ModalHeaderBlack = styled(Modal.Header)`
  /* background: var(--bg-modal-header); */

  /* color: var(--fore-primary); */
  color: var(--caption-fore-color);
  border-color: var(--date-border);
  font-family: "prompt";
  font-size: 20px;
  text-align: center;
  /* flex: 1; */
  background: var(--bg-modal-header);
  padding: 5px 10px 5px 5px;
`;

export const ModalBodyBlack = styled(Modal.Body)`
  background: var(--bg-primary);
  border: none;
  padding: 0px;
`;

export const ModalInputLabelBlack = styled(InputGroup.Text)`
  background: var(--bg-primary);
  color: var(--fore-secondary);
  border: none;
  width: 150px;
  margin: 0 0 0 0px;
  /* @media only screen and (max-width:600px){
            width: 50px;
        }
        @media only screen and (min-width:600px){
            width: 150px;
        } */
`;

export const ModalFooterBlack = styled(Modal.Footer)`
  background: var(--bg-primary);
  border: none;
`;

export const LabelGrey = styled(InputGroup.Text)`
  background: var(--bg-secondary);
  color: var(--fore-primary);
  border: none;
  flex: 2;
  /* width: 70%; */
  margin: 0 0 0 0px;
  border-radius: 0px, 3px;
  overflow-x: hidden;
`;

export const ModalInputTextBlack = styled(FormControl)`
  background-color: var(--bg-secondary);
  color: var(--fore-primary);
  border: none;
  /* flex: 3;  */
  &:active {
    background-color: var(--bg-primary);
  }
  &:focus {
    background-color: var(--bg-primary);
    display: inline-block;
    box-shadow: 0 0 0 0.1rem #aaf;
    backdrop-filter: blur();
    border-radius: 5px;
    color: var(--fore-primary);
  }
  &:disabled {
    background-color: var(--bg-primary);
    color: var(--fore-primary);
  }
`;

export const ModalSelectBlack = styled(Form.Select)`
  background-color: var(--bg-secondary);
  color: var(--fore-primary);
  border: none;
`;

export const FormCheckBlack = styled(Form.Check)`
  background: var(--bg-primary);
  color: var(--fore-primary);
`;

export const FormDate = styled(Form.Control)`
  /* background: var(--bg-primary); */
  background: var(--bg-secondary);
  /* color: var(--table-text-color); */

  border: none;
  /* flex: 3;  */
  &:active {
    background-color: var(--bg-primary);
  }
  &:focus {
    background-color: var(--bg-primary);
    display: inline-block;
    box-shadow: 0 0 0 0.1rem #aaf;
    backdrop-filter: blur();
    border-radius: 5px;
    color: var(--table-text-color);
  }
`;

export const DateTimePickerBlack = styled(DateTimePicker)`
  color: black; //var(--table-text-color);
  border: none;
  background: var(--bg-secondary);
  min-width: 220px;

  &:active {
    background-color: #6f6a6a;
    color: black;
  }
  &:focus {
    background-color: black;
    display: inline-block;
    box-shadow: 0 0 0 0.1rem #aaf;
    backdrop-filter: blur();
    border-radius: 5px;
    //color: var(--table-text-color);
    color: black;
  }
`;

export const RadConnStyle = {};
